import Modal from '../../../../../commons/Modal/Modal';
import { DashboardCommerciauxCreateModalProps } from './DashboardCommerciauxCreateModal.types';
import DashboardCommerciauxForm from './DashboardCommerciauxForm/DashboardCommerciauxForm';

export default (props: DashboardCommerciauxCreateModalProps) => {

  return (
    <Modal {...props}>
      <DashboardCommerciauxForm />
    </Modal>
  );
};
